import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';

const sizes = { sm: 'max-w-sm', md: 'max-w-md', lg: 'max-w-lg', xl: 'max-w-xl', '2xl': 'max-w-2xl' };

const Modal = ({ isOpen, onClose, title, children, footer, size = 'md', closeOnBackdrop = true, showCloseButton = true, className = '' }) => {
  useEffect(() => { document.body.style.overflow = isOpen ? 'hidden' : 'unset'; return () => { document.body.style.overflow = 'unset'; }; }, [isOpen]);
  useEffect(() => { const h = (e) => { if (e.key === 'Escape' && isOpen) onClose(); }; document.addEventListener('keydown', h); return () => document.removeEventListener('keydown', h); }, [isOpen, onClose]);
  if (!isOpen) return null;
  return createPortal(
    <>
      <div className="fixed inset-0 bg-black/50 z-[100] animate-fade-in" aria-hidden="true" />
      <div className="fixed inset-0 z-[100] flex items-center justify-center p-4"
        onClick={(e) => { if (closeOnBackdrop && e.target === e.currentTarget) onClose(); }}
        role="dialog" aria-modal="true">
        <div className={`bg-white rounded-2xl shadow-modal w-full ${sizes[size] || sizes.md} overflow-hidden animate-slide-up ${className}`}>
          {(title || showCloseButton) && (
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
              {title && <h2 className="text-lg font-semibold text-gray-900">{title}</h2>}
              {showCloseButton && <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg transition-colors ml-auto"><X className="w-5 h-5 text-gray-500" /></button>}
            </div>
          )}
          <div className="px-6 py-4">{children}</div>
          {footer && <div className="flex gap-3 px-6 py-4 border-t border-gray-100 bg-gray-50">{footer}</div>}
        </div>
      </div>
    </>,
    document.body
  );
};

export default Modal;
